import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EventCenterS {
    shoLoginDialog = new Subject<boolean>();
    loadAddToCard = new Subject<boolean>();
    loadAddWishlist  = new Subject<boolean>();
    loadAddWishlistProductDetailsPage  = new Subject<boolean>();
    refreshOrderSummary  = new BehaviorSubject<any>(null);

    // register this subject to listen window resize events.

    constructor() {
    }

}
